module.exports = "/images/family_grey.png?3e8278fafd8d2bf940b38349cce1e3e3";